import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import TableWidget from "../../../components/tables/TableWidget";
import {
  getTransportHistoryTableData,
  transportHistoryTableHeader,
} from "./components/tableConfigs/transportHistoryTableConfig";
import TransportHistoryActionButton from "./components/TableActionsButtonsComponent/TransportHistoryActionButton";
import { fetchTransportHistory } from "../../../redux/api/transport.api";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import { clearTransportHistoryData } from "../../../redux/reducer/transport.reducer";

function TransportHistory() {
  const dispatch = useAppDispatch();

  const {
    transport: {
      transportHistory: {
        data: { data: transportHistory, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    transport: state.transport,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableFilter &&
      action.tableSearch
    ) {
      dispatch(
        fetchTransportHistory({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          ruta: action.tableFilter.ruta,
          masina: action.tableSearch.masina,
          sofer: action.tableSearch.sofer,
        }),
      );
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearTransportHistoryData());
    };
  }, [dispatch]);

  return (
    <TableWidget
      tableTitle="Istoric transporturi"
      tableHeaderData={transportHistoryTableHeader}
      tableItemsData={getTransportHistoryTableData(transportHistory)}
      tableLoading={isLoading}
      ActionButtonsComponent={TransportHistoryActionButton}
      handleTableActions={handleTableActions}
      totalItems={total}
      borderedRow
    />
  );
}

export default TransportHistory;
